import React from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function ReAuthModal({
  isOpen,
  title = "Re-authenticate",
  description = "Enter your password to continue.",
  password,
  onPasswordChange,
  showPassword,
  onTogglePassword,
  error,
  loading,
  attemptsRemaining,
  maxAttempts,
  onCancel,
  onConfirm,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1057 }} />
      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1058 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 border-0 shadow-lg">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-bold hc-text-primary">{title}</h5>
            </div>
            <div className="modal-body py-3">
              <p className="text-secondary mb-3 small">{description}</p>
              {typeof attemptsRemaining === "number" && typeof maxAttempts === "number" ? (
                <p className="text-secondary mb-2 small">
                  Attempts remaining: {attemptsRemaining} of {maxAttempts}
                </p>
              ) : null}
              <div className="position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form-control form-control-sm hc-input${error ? " is-invalid" : ""}`}
                  placeholder="Password"
                  value={password}
                  autoFocus
                  style={{ paddingRight: error ? "70px" : "40px", height: "40px" }}
                  onChange={(e) => onPasswordChange?.(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && !loading && onConfirm?.()}
                />
                <button
                  type="button"
                  className="btn btn-link p-0 position-absolute top-50 translate-middle-y text-secondary"
                  style={{ right: error ? "34px" : "10px", lineHeight: 0 }}
                  tabIndex={-1}
                  onClick={onTogglePassword}
                >
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
              {error && <div className="invalid-feedback d-block">{error}</div>}
            </div>
            <div className="modal-footer border-0 pt-0 gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm rounded-3 px-3"
                disabled={loading}
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn hc-bg-primary text-white btn-sm rounded-3 px-3"
                disabled={loading}
                onClick={onConfirm}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                )}
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
